import { Profile } from "../types/profile";
import { ACTION_TYPES, getDataNoParams, postData } from "./modelUtils";

export const getProfile = async (): Promise<Profile> => {
  return await getDataNoParams({
    action: ACTION_TYPES.GET_PROFILE,
    labelLogName: "profile",
    dataField: "profile",
  });
};

export const onboardProfile = async (): Promise<Profile> => {
  return await postData({
    action: ACTION_TYPES.ONBOARD_PROFILE,
    labelLogName: "profile",
    labelActionName: "to onboard",
    dataField: "profile",
    fields: {},
  });
};
